module.exports = __webpack_public_path__ + "static/media/mobileViewer.88b4d2d9.svg";